import { render, staticRenderFns } from "./ClientCountryPieChart.vue?vue&type=template&id=0ae9724e&scoped=true&"
import script from "./ClientCountryPieChart.vue?vue&type=script&lang=js&"
export * from "./ClientCountryPieChart.vue?vue&type=script&lang=js&"
import style0 from "./ClientCountryPieChart.vue?vue&type=style&index=0&id=0ae9724e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae9724e",
  null
  
)

export default component.exports